import { render } from "./SectionEmployeeAttendance.vue?vue&type=template&id=c6196cc8&scoped=true"
import script from "./SectionEmployeeAttendance.vue?vue&type=script&lang=js"
export * from "./SectionEmployeeAttendance.vue?vue&type=script&lang=js"

import "./SectionEmployeeAttendance.vue?vue&type=style&index=0&id=c6196cc8&scoped=true&lang=css"

import exportComponent from "/Users/alvinvergara/Developer/Lead Dev - Projects/DAP/iwc_dap/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c6196cc8"]])

export default __exports__